import { html } from 'lit-html';
import { RrAreaFromExternalSite } from '../../../../core/views/pc/rr_item/rr_area_from_external_site';
import { RrAreaLeftSide } from '../../../../core/views/pc/rr_item/rr_area_left_side';
import { RrAreaNormal } from '../../../../core/views/pc/rr_item/rr_area_normal';
import { CategoryMJsEnv } from '../../models/category_m_js_env';

// prettierの自動整形をしたくない場合だけ付与する
// prettier-ignore

export const RrBodyM1 = (model: CategoryMJsEnv) => html`
${RrAreaFromExternalSite(model.rrAreaProfileM1, model.isLogin)}
`;

export const RrBodyM2 = (model: CategoryMJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileM2, model.isLogin)}
`;

export const RrBodyM3 = (model: CategoryMJsEnv) => html`
${RrAreaLeftSide(model.rrAreaProfileM3, model.isLogin)}
`;
